export default __webpack_public_path__ + "static/media/artificial-intelligence-png.b60ae19c.png";